import OriginalChip from './Chip.svelte';
import Avatar from './Avatar.svelte';
import Label from './Label.svelte';
import Close from './Close.svelte';
const Chip = OriginalChip;
Chip.Avatar = Avatar;
Chip.Label = Label;
Chip.Close = Close;
export default Chip;
